import * as api from '../../services/api_credential/api_api_credential';
import * as common from '../sagasCommon';
import { browserHistory } from 'react-router';
import { 
  all,
  call,
  fork,
  put,
  takeLatest,
} from 'redux-saga/effects';


export default function* (app) {
  return yield all([
    fork(deleteApiCredentialSaga, app),
    fork(fetchApiCredentialForEditSaga, app),
    fork(fetchApiCredentialListSaga, app),
    fork(saveApiCredentialSaga, app),
  ]);
}


export function* saveApiCredentialSaga(app) {
  yield takeLatest('SAVE_API_CREDENTIAL', callSaveApiCredential, app);
}

function* callSaveApiCredential(app, action) {
  try {
    const { data } = action;
    yield common.showProgressSaveRecord();

    const result = yield call(api.saveApiCredential, data, app);
    const id = result && result.client_id;

    yield call(callFetchApiCredentialForEdit, app, { id });
    browserHistory.push(`/admin/api_credential/edit/${id}`);
    yield call(common.doneSaveRecord, result, 'API Credential was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}


export function* fetchApiCredentialForEditSaga(app) {
  yield takeLatest('FETCH_API_CREDENTIAL_FOR_EDIT', callFetchApiCredentialForEdit, app);
}

function* callFetchApiCredentialForEdit(app, action) {
  try {
    yield common.showProgressDataById();
    const { id } = action;
    const doc = yield call(api.fetchApiCredentialById, id, app);
    yield call(common.doneDataById, doc);
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}


export function* fetchApiCredentialListSaga(app) {
  yield takeLatest('FETCH_API_CREDENTIAL_LIST', callFetchApiCredentialList, app);
}

function* callFetchApiCredentialList(app, action) {
  const { silent, filters } = action;
  yield common.showProgressListTable(silent);
  try {
    const tableData = yield call(api.fetchApiCredentialList, app, filters);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}


export function* deleteApiCredentialSaga(app) {
  yield takeLatest('DELETE_API_CREDENTIAL', callDeleteApiCredential, app);
}

function* callDeleteApiCredential(app, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    yield call(api.deleteApiCredential, id, app);
    yield call(common.doneDeleteRecord, id, 'api_credential');
    browserHistory.push('/admin/task');
  } catch (error) {
    yield common.showErrorDeleteRecord(error);
  }
}